module.exports = __webpack_public_path__ + "app/assets/images/woman12-571af7df91f51061bab2bf60435f5891.jpg";